import { createFileRoute } from '@tanstack/react-router';
import { AdminFeatureFlagsView } from '@/components/admin/AdminFeatureFlagsView';

export const Route = createFileRoute('/_authed/admin/feature-flags/')({
  component: AdminFeatureFlagsView,
});
